import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';
import { NekoButton } from '../button/Button';

const NekoModalParent = Styled.div`

  .ReactModal__Overlay {
    z-index: 100;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background: ${Theme.overlay} !important;
  }
  .ReactModal__Overlay {
    opacity: 0;
    transition: opacity 200ms ease-in-out;
  }
  .ReactModal__Overlay--after-open  {
    opacity: 1;
  }
  .ReactModal__Overlay--before-close {
    opacity: 0;
  }
  .ReactModal__Overlay .neko-modal {
    opacity: 0;
    transform: scale(0.85);
    transition: all 200ms ease-in-out;
  }
  .ReactModal__Overlay--after-open .neko-modal {
    transform: scale(1);
      opacity: 1;
  }
  .ReactModal__Overlay--before-close .neko-modal {
      transform: scale(0.85);
      opacity: 0;
  }
  .neko-modal {
    background: ${Theme.white};
    position: relative;
    box-shadow: 2px 2px 15px 2px rgba(0, 0, 0, 0.8);
    outline: none;
    padding: 15px;
    max-width: 820px;
  }
`;

const NekoModalContent = Styled.div`
  width: 518px;

  p {
    margin: 0;
  }
  .title {
    font-family: ${Theme.fontFamily};
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
  }
  .content {
    font-family: ${Theme.fontFamily};
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 14px;
    margin-top: 15px;
    margin-bottom: 30px;
  }
  .button-group {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
  }
`;

const StyledNekoModal = (props) => {

  const {
    children,
    className,
    style,
    ok = 'OK',
    cancel = 'Cancel',
    customButtons = null,
    customButtonsPosition = 'right',
    title = '',
    content = '',
    onOkClick,
    onCancelClick,
    ...rest
  } = props;
  const customClassName = style ? 'custom-modal' : '';
  const showCustomButtons = customButtons !== null;

  const modalContent = children
    ? children
    : <NekoModalContent>
        {title && <p className="title">{title}</p>}
        {content && <p className="content">{content}</p>}
        <div className="button-group">
          {showCustomButtons && customButtonsPosition === 'left' && customButtons}
          {onCancelClick && <NekoButton className="danger" onClick={onCancelClick}>{cancel}</NekoButton>}
          {onOkClick && <NekoButton onClick={onOkClick}>{ok}</NekoButton>}
          {showCustomButtons && customButtonsPosition === 'right' && customButtons}
        </div>
      </NekoModalContent>;

  return (
      <React.Fragment>
        <NekoModalParent id="neko-modal-parent" />
        <Modal ariaHideApp={false}
          parentSelector={() => document.getElementById('neko-modal-parent')}
          closeTimeoutMS={200}
          className={`neko-modal ${className || ''} ${customClassName}`}
          {...rest}
        >
          {modalContent}
        </Modal>
      </React.Fragment>
  );
};

const NekoModal = (props) => {
  return (<StyledNekoModal {...props} />);
};

NekoModal.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  ok: PropTypes.string,
  cancel: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  onOkClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  customButtons: PropTypes.object
};

NekoModal.defaultProps = {
  className: undefined,
  style: undefined,
  ok: 'OK',
  cancel: 'Cancel',
  title: '',
  content: '',
  onOkClick: undefined,
  onCancelClick: undefined,
  customButtons: null
};

export { NekoModal };
